/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, identity, RestSettings, SlicedDataSource } from '@gh/core-data';
import { Observable } from 'rxjs';
import { CareerInquiryDetailsDto } from './career-enquiries-details.dto';
import { ID } from '@gh/common-shared-data';

@Injectable()
export class CareerEnquiriesRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  findAllAsDataSource(filter: any = {}): SlicedDataSource<CareerInquiryDetailsDto> {
    return this.createSlicedDataSourceGet(`${this.bp}/career-enquiry/list`, filter, identity(), identity());
  }

  markDeleted(careerEnquiryId: ID, status: boolean): Observable<any> {
    return this.httpPut(`${this.bp}/career-enquiry/status/${careerEnquiryId}?markAsDeleted=${status}`, {}, identity());
  }
}
